"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    { name: '大韓民国', value: 'KR' },
    { name: 'アメリカ', value: 'US' },
    { name: '日本', value: 'JP' },
    { name: '中国', value: 'CN' },
    { name: '台湾', value: 'TW' },
    { name: 'タイ', value: 'TH' },
    { name: 'ガーナ', value: 'GH' },
    { name: 'インドネシア', value: 'ID' },
    { name: 'ベトナム', value: 'VN' },
    { name: 'シンガポール', value: 'SG' },
    { name: 'マレーシア', value: 'MY' },
    { name: 'カナダ', value: 'CA' },
    { name: 'フィリピン', value: 'PH' },
    { name: '香港', value: 'HK' },
    { name: 'アメリカ領ヴァージン諸島', value: 'VI' },
    { name: 'オーストラリア', value: 'AU' },
    { name: 'フランス', value: 'FR' },
    { name: 'ドイツ', value: 'DE' },
    { name: 'ブラジル', value: 'BR' },
    { name: 'イギリス', value: 'GB' },
    { name: 'ロシア', value: 'RU' },
    { name: 'メキシコ', value: 'MX' },
    { name: 'ニュージーランド', value: 'NZ' },
    { name: 'インド', value: 'IN' },
    { name: 'スウェーデン', value: 'SE' },
    { name: 'ペルー', value: 'PE' },
    { name: 'スペイン', value: 'ES' },
    { name: 'チリ', value: 'CL' },
    { name: 'ミャンマー', value: 'MM' },
    { name: 'トーゴ', value: 'TG' },
    { name: 'ノルウェー', value: 'NO' },
    { name: 'アルゼンチン', value: 'AR' },
    { name: 'グアテマラ', value: 'GT' },
    { name: 'フィンランド', value: 'FI' },
    { name: 'ポルトガル', value: 'PT' },
    { name: 'ブルガリア', value: 'BG' },
    { name: 'フォークランド諸島（マルビナス）', value: 'FK' },
    { name: 'イスラエル', value: 'IL' },
    { name: 'ラトビア', value: 'LV' },
    { name: 'アラブ首長国連邦', value: 'AE' },
    { name: 'オランダ', value: 'NL' },
    { name: 'アンギラ', value: 'AI' },
    { name: 'ホンジュラス', value: 'HN' },
    { name: 'コロンビア', value: 'CO' },
];
